/* global window */

import React, { Component } from 'react';
import { Route, Switch, withRouter } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { history } from './store';

// components
import SiteHeader from './layout/SiteHeader';
import EventFeed from './layout/EventFeed';
import ScrollToTop from './layout/ScrollToTop';
import IconNavBar from './layout/IconNavBar';

import './css/App.css';

// actions
import { getEvents } from './actions/cardEvents';
import { getCardTemplates } from './actions/cardTemplates';
import { loginUser, getUser } from './actions/user';
import { loginSofologistFromJWT, getCashPaymentConfig } from './actions/sofologist';
import { getBasketsforUser } from './actions/baskets';
import { updateActivity } from './actions/activity';

// services
import { getUserCookieOrSendToLogin } from './services/AuthService';
import { getSofologistCookie } from './services/cookieService';
import { loadIntercom } from './services/intercomService';

// pages
import NotFoundPage from './pages/NotFoundPage';
import GhostButton from './parts/GhostButton';

// config
import { config } from './config';


function RenderEmptyBasketFeed() {
  return (
    <div className="c-event-feed__empty-msg u-padding-small">
      <h3 >It looks like you have no items in your basket.</h3>
      <GhostButton
        text="continue shopping"
        onBtnClick={() => { window.location = config.URLS.SOFOLOGY_HOME; }}
      />
    </div>
  );
}

export class _App extends Component {

  constructor(props) {
    super(props);
    this.checkEvents = null;

    // sofologist Auth
    const sofologistCookie = getSofologistCookie();
    if (sofologistCookie) {
      if (sofologistCookie.fromLegacyImpersonation) {
        history.push('/admin');
      }
      if (sofologistCookie.token && sofologistCookie.location) {
        props.loginSofologistFromJWT(sofologistCookie);
        props.getCashPaymentConfig(Date.now);
      } else {
        props.sofologistLogout();
      }
    }

    // User Auth
    getUserCookieOrSendToLogin()
      .then((user) => {
        this.props.loginUser(user);
        this.props.getEvents();
        this.props.getCardTemplates();
        this.props.getUser();
        this.props.getBasketsforUser();
        this.props.updateActivity();
        if (!getSofologistCookie()) {
          loadIntercom(user.retailExperienceUser.username);
        }
      });
  }

  componentDidMount() {
    this.checkEvents = window.setInterval(() => {
      this.props.getEvents();
      this.props.getCardTemplates();
      this.props.getBasketsforUser();
    }, 60000);
  }

  componentWillUnmount() {
    clearInterval(this.checkEvents);
  }

  render() {
    return (
      <ScrollToTop>
        <div className="u-padding-bottom-huge">
          {/* GT-461: Skip to main content link - hidden until focused via keyboard */}
          <a href="#main-content" className="c-skip-link">Skip to main content</a>
          <SiteHeader loggedin={this.props.Authorized} />
          {
            this.props.Authorized === false ? null : (
              <main id="main-content" className="main-wrapper" tabIndex="-1">
                <Switch>
                  <Route exact path="/orders" component={EventFeed} />
                  <Route
                    exact
                    path="/basket"
                    component={() => <EventFeed emptyFeedContent={RenderEmptyBasketFeed()} />}
                  />
                  <Route exact path="/" component={EventFeed} />
                  <Route exact path="/help" component={EventFeed} />
                  <Route exact path="/account" component={EventFeed} />
                  <Route component={NotFoundPage} />
                </Switch>
              </main>
            )
          }
          <IconNavBar />
        </div>
      </ScrollToTop>
    );
  }
}

const mapStateToProps = state => ({
  Authorized: state.user.Authorized || true
});

const mapDispatchToProps = dispatch => bindActionCreators({
  loginUser, getEvents, getCardTemplates, getUser,
  loginSofologistFromJWT, getBasketsforUser, updateActivity, getCashPaymentConfig
}, dispatch);

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(_App));



// WEBPACK FOOTER //
// ./src/App.js